<script lang="ts">
    import IconNoContent from '../icons/NoContentIcon.svelte';
    import * as t from '../translations/News.ts';
</script>

<div class="flex flex-col items-center justify-center text-center px-4 py-12 text-gray-600">
    <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-6">
        <IconNoContent width={40} height={40} class="text-teal-700" />
    </div>
    <h2 class="text-xl font-semibold text-gray-800"> {t.Empty_State_Title()}</h2>
    <p class="mt-2 text-sm text-gray-500">{t.Empty_State_Description()}</p>
</div>